import React from 'react'
import styles from './size-info.module.scss'
import image from '../../../assets/images/size-info/skirt.png'
import styled from 'styled-components'

function PencilSkirt() {
  return (
    <div className={styles.sizeInfo}>
      <div>
        <h2 className={styles.sizeInfoTitle}>
          Возьмите Вашу любимую облегающую юбку и проведите измерения:
        </h2>
      </div>
      <Container columns="4fr 8fr">
        <div className={styles.sizeInfoImage}>
          <img loading="lazy" src={image} />
        </div>
        <div>
          <ol>
            <li>Измерьте ширину пояса Вашей юбки (в см).</li>
            <li>Измерьте ширину в бёдрах (в см).</li>
            <li>Измерьте ширину низа Вашей юбки (в см).</li>
            <li>
              Измерьте длину от Вашей талии до отметки чуть ниже колен (в см).
            </li>
            <li>
              В нашей таблице размеров найдите показатели, которые наиболее
              точно соответствуют получившимся цифрам.
            </li>
          </ol>
          <p>
            Если у Вас нет облегающей юбки для снятия мерок, то можно измерить
            обхват талии, бёдер и ног под коленями и разделить этот результат на
            2, затем прибавив 1-2 см к получившемуся.
          </p>
        </div>
      </Container>
    </div>
  )
}

const Container = styled.div`
  @media (min-width: 940px) {
    display: grid;
    grid-template-columns: ${(p) => p.columns};
  }
`

PencilSkirt.propTypes = {}

export default PencilSkirt
